import {SagaIterator} from 'redux-saga';
import {call, put, all} from 'redux-saga/effects';

import {AddressType} from 'desktop/types/addressType';

import {saveBillingAddress} from '../../../reducers/deliveryStep/billingAddress/billingAddress';
import {saveShippingAddress} from '../../../reducers/deliveryStep/shippingAddress/shippingAddress';
import {targets} from '../updateOrderReviewShippingInfoSaga/updateOrderReviewShippingInfoSaga';

/**
 * Updates one or both addresses in store using received address
 * @param {AddressType} address - Received actual address to update
 * @param {boolean} updateBoth - Should I update booth addresses instead of only one of them
 * @param {string} target - Target for updating single address
 */
export function* updateAddress(
    address: AddressType,
    updateBoth: boolean,
    target: string,
): SagaIterator {
    if (updateBoth) {
        const [saveShippingAddressAction, saveBillingAddressAction] = yield all([
            call(saveShippingAddress, address),
            call(saveBillingAddress, address),
        ]);
        yield all([put(saveShippingAddressAction), put(saveBillingAddressAction)]);
    } else {
        const saveAddressAction = yield call(targets[target].action, address);
        yield put(saveAddressAction);
    }
}
